/**
 * A global namespace for `Control` key.
 * e.which = 17
 */
const keyControl = "Control";

export default keyControl;
